import BaseStore from './BaseStore';
import _ from 'lodash';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import { runInAction } from 'mobx';
// import { notification } from 'antd'

const defaultData = {
  search: false,
  reset: true,
  hnStatus: true,
  name: '',
  patient: {
    hn: '',
    firstname: '',
    lastname: '',
    firstnameEn: '',
    lastnameEn: '',
    gender: 'M',
    dob: '',
    note: '',
    imgProfileUrl: '',
    weight: 0,
    height: 0,
  },
};

const defaultDevices = {
  list: [],
  selected: {
    id: 0,
    label: null,
    value: {},
  },
};

export class PatientStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      data: _.cloneDeep(defaultData),
      devices: _.cloneDeep(defaultDevices),
      patientList: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      tenantIds: null,
      userInformation: [],
      markerData: [],
      action: null,
      searchPatients: [],
      allPatients: [],
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.patientList = [];
    this.allPatients = [];
  }

  async setPagination(task, data, getPatient = true) {
    this[task] = data;
    if (getPatient) {
      this.getPatient(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async setPaginationForAllPatients(task, data, getPatient = true) {
    this[task] = data;
    if (getPatient) {
      this.getAllPatients(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  resetDeviceSelect() {
    const deviceList = this.devices.list;
    const defaultDevices = {
      list: deviceList,
      selected: {
        id: 0,
        label: null,
        value: {},
      },
    };
    this.devices = defaultDevices;
  }

  setHnStatus(status) {
    this.data.hnStatus = status;
  }

  setData(result) {
    result.reset = true;
    this.data = result;
  }

  setReset(status) {
    this.data.reset = status;
  }

  clearSelectDevice() {
    this.devices.selected = {
      id: 0,
      label: null,
      value: {},
    };
  }

  addDevice() {
    let devices = this.data.patient.devices;
    devices.push(this.devices.selected.value);
    devices.map((val) => {
      val.status = 'ACTIVATE_ON';
      return val;
    });
    this.data.patient.devices = devices;
  }

  changeData(key, value) {
    this.data.patient[key] = value;
  }

  setDeviceList(devices) {
    this.devices.list = devices;
  }

  setDeviceSelect(device) {
    if (device) {
      const deviceFilter = (this.devices.list || []).find((d) => d.id === device.value);
      if (deviceFilter) {
        this.devices.selected.id = device.value;
        this.devices.selected.label = device;
        this.devices.selected.value = deviceFilter;
      }
    } else {
      this.devices.selected = {
        id: 0,
        label: null,
        value: {},
      };
    }
  }

  activateDevice(id, checked) {
    let devices = (this.data.patient.devices || []).map((device) => {
      if (device.id === id) {
        device.status = checked ? 'ACTIVATE_ON' : 'ACTIVATE_OFF';
      }
      return device;
    });
    this.data.patient.devices = devices;
  }

  // async remoteDeleteDevice(index) {
  //   let devices = this.data.patient.devices
  //   devices.splice(index, 1);
  //   this.data.patient.devices = devices;
  // }
  async remoteDeleteDevice(datas) {
    const assign = this.data.patient.devices.filter((v) => {
      const found = (datas || []).find((d) => d.id === v.id);
      return !found;
    });
    this.data.patient.devices = assign;
  }

  async unAssignDevice(index) {
    let devices = this.data.patient.devices;
    devices.splice(index, 1);
    this.data.patient.devices = devices;
  }

  remoteDelete(deletedIndexes) {
    let devices = this.data.patient.devices;
    for (let i = deletedIndexes.length - 1; i >= 0; i--) {
      devices.splice(deletedIndexes[i], 1);
    }
    this.data.patient.devices = devices;
  }

  formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = +datePart[0] + 543, // get only two digits
      month = datePart[1],
      day = datePart[2];
    return day + '/' + month + '/' + year;
  }

  async getPatientById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/patient/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let patient = res.body;
        return patient;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 500);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getPatientByHN() {
    let hn;
    if (this.data.patient) {
      hn = this.data.patient.hn;
    } else {
      hn = '';
    }
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/patient/hn/${encodeURIComponent(hn)}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let patients = res.body;
        if (patients.id) {
          this.data.patient = patients;
          this.data.patient.dob = this.formatDate(patients.dob);
          this.data.patient.gender = patients.gender ? patients.gender.toUpperCase() : patients.gender;
          this.data.search = true;
        } else {
          this.data = defaultData;
        }
        return patients;
      }
    } catch (err) {
      this.data = defaultData;
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 500);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getPatientBySearch(search, tenantIds) {
    this.loading = true;
    if (tenantIds) {
      console.log('tenantIds: ', tenantIds);
      try {
        let url = `${config.api.url}/${config.api.version}/patient/search/all`;
        const res = await rp
          .get(url, {
            qs: {
              search,
              tenantIds: JSON.stringify(tenantIds),
            },
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          let patients = res.body;
          this.searchPatients = patients;
        }
      } catch (err) {
        this.data = defaultData;
        if (err.statusCode === 401) {
          setTimeout(() => {
            clearLocalStorage();
            window.location.href = '/login';
          }, 500);
        }
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  async getPatient(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/patient/cms`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let patientList = res.body || {};
        patientList.data.map((val) => {
          val.gender = val.gender ? val.gender.toUpperCase() : val.gender;
          return val;
        });
        return (this.patientList = patientList);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 500);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getAllPatients(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (localStorage.getItem('role_id') === '1') {
      queryOption.includedTest = true;
    }
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/patient/all`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let patients = res.body || {};
        patients.data.map((val) => {
          val.gender = val.gender ? val.gender.toUpperCase() : val.gender;
          return val;
        });
        return (this.allPatients = patients);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 500);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async patientCreate(data) {
    this.loading = true;
    try {
      // if (data.dob === '0000-00-00') {
      //   data.dob = null
      // }
      const detail = {
        tenantId: data.tenantId,
        hn: data.hn,
        firstname: data.firstname,
        lastname: data.lastname,
        firstnameEn: data.firstnameEn,
        lastnameEn: data.lastnameEn,
        gender: data.gender,
        dob: data.dob,
        weight: data.weight ? parseFloat(data.weight).toFixed(2) : 0,
        height: data.height ? parseFloat(data.height).toFixed(2) : 0,
        status: 'DISCHARGED',
        contactFirstname: data.contactFirstname,
        contactLastname: data.contactLastname,
        contactPhone: data.contactPhone,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/patient`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      // console.log('error', err)
      // throw new Error(err.error.message);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async patientUpdate(data) {
    this.loading = true;
    try {
      const detail = data;
      detail.weight = detail.weight ? parseFloat(detail.weight).toFixed(2) : 0;
      detail.height = detail.height ? parseFloat(detail.height).toFixed(2) : 0;
      // console.log('==>', detail)
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/patient/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      // throw new Error(err.error.message);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deletePatient(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/patient/softdelete/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      // throw new Error(err.error.message);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findMapBySubgroupIds(subgroupIds) {
    this.loading = true;
    if (subgroupIds === '0') {
      subgroupIds = 0;
    }
    if (subgroupIds) {
      try {
        const data = { subgroupIds: JSON.parse(subgroupIds) };
        let url = `${config.api.url}/${config.api.version}/patient/subgroup`;
        const res = await rp
          .post(url, {
            body: data,
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          const marker = [];
          const data = res.body || [];
          if (data.length > 0) {
            data.map((val) => {
              marker.push({
                position: { lat: val.homeUserAddress.latitude, lng: val.homeUserAddress.longitude },
                userAddress: val.homeUserAddress,
                patients: val.patients,
                subgroup: val.subGroup,
              });
              return val;
            });
          }
          runInAction(() => {
            this.markerData = marker;
            this.userInformation = data;
          });
        }
      } catch (err) {
        if (err.statusCode === 401) {
          setTimeout(() => {
            clearLocalStorage();
            window.location.href = '/login';
          }, 1000);
        }
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  setUserInformation(position) {
    let information = this.userInformation;
    information.forEach((element, index) => {
      if (element.homeUserAddress.latitude === position.lat && element.homeUserAddress.longitude === position.lng) {
        let newArray = information.splice(index, 1);
        information.unshift(newArray[0]);
      }
    });

    this.userInformation = information;
  }

  async getPatientIdByUserId(userId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/patient/user/${userId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body || {};

        return data;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 500);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateNote(id) {
    this.loading = true;
    try {
      const detail = {
        note: this.data.patient.note,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/patient/note/${id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateProfileImage(data) {
    this.loading = true;
    try {
      const imgProfileUrl = data;
      // console.log('==>', imgProfileUrl)
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/patient/profile/image/${data.id}`, {
          body: imgProfileUrl,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new PatientStore();
